/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/passkey'
export default icon
